import { useEffect, useState } from "react";
import { Association } from "src/interfaces/Common";
import { PagesID } from "@utils/utilsConfigurations";
import { ServicesURL } from "@utils/utilsApi";
import { useParams } from "react-router";

export const useAddEditDetailCost = (dataDetail?: any, dataCostModel?: any) => {
  const { id } = useParams();
  const [openAssociations, setOpenAssociations] = useState<
    boolean | Association
  >(false);
  const [supplierAssociation, setSupplierAssociation] = useState<any>([]);
  const [contractAssociation, setContractAssociation] = useState<any>([]);

  const formatSupplier = (supplier: any) => {
    supplier.label = `${supplier.business_name} - ${supplier.sap_code}`;
    setSupplierAssociation([supplier]);
  };

  const formatContract = (contract: any) => {
    contract.label = `${contract.sap_number} - ${contract.name}`;
    setContractAssociation([contract]);
  };

  useEffect(() => {
    if (dataDetail?.supplier) {
      formatSupplier(dataDetail.supplier);
    }
    if (dataDetail?.contract) {
      formatContract(dataDetail.contract);
    }
  }, [dataDetail]);

  const resetContractAssociations = () => {
    if (dataDetail?.supplier) {
      formatSupplier(dataDetail.supplier);
    } else {
      setSupplierAssociation([]);
    }

    if (dataDetail?.contract) {
      formatContract(dataDetail.contract);
    } else {
      setContractAssociation([]);
    }
  };

  const setOpenAssociation = (accessorKey: string, value: boolean) => {
    switch (accessorKey) {
      case "supplier":
        setOpenAssociations(
          value
            ? {
                accessorKey: "supplier",
                mediaType: "supplier",
                type: "table",
                titleKey: "supplier-association",
                pageId: PagesID["suppliers"],
                service: `${ServicesURL.getSuppliers}?corporateId=${id}`,
                multiChoice: false,
              }
            : value,
        );
        break;
      case "contract":
        setOpenAssociations(
          value
            ? {
                accessorKey: "contract",
                mediaType: "contract",
                type: "table",
                titleKey: "contract-association",
                pageId: PagesID["contracts"],
                service: `${ServicesURL.getContracts}?corporateId=${id}&supplierId=${supplierAssociation[0]?.id || ""}&accountId=${dataCostModel?.dto?.account?.id || ""}`,
                multiChoice: false,
              }
            : value,
        );
        break;
    }
  };

  const getValues = (accessorKey: string) => {
    switch (accessorKey) {
      case "supplier":
        return supplierAssociation;
      case "contract":
        return contractAssociation;
    }
  };

  const handleDelete = (accessorKey: string, e: any) => {
    switch (accessorKey) {
      case "supplier":
        setSupplierAssociation(
          supplierAssociation.filter((element: any) => element.id !== e.id),
        );
        break;
      case "contract":
        setContractAssociation(
          contractAssociation.filter((element: any) => element.id !== e.id),
        );
        break;
    }
  };

  const handleAssociation = (accessorKey: string, value: any) => {
    switch (accessorKey) {
      case "supplier":
        const objToSupplierAssociation: any = Object.keys(value).map(
          (key: string) => {
            if (key.includes("||")) {
              return {
                id: key.split("||")[0],
                label: key.split("||")[1],
                key: key.split("||")[2],
              };
            } else {
              return supplierAssociation.find((elem: any) => elem.id === +key);
            }
          },
        );
        setSupplierAssociation(objToSupplierAssociation);
        break;
      case "contract":
        const objToContractAssociation: any = Object.keys(value).map(
          (key: string) => {
            if (key.includes("||")) {
              return {
                id: key.split("||")[0],
                label: key.split("||")[1],
              };
            } else {
              return contractAssociation.find((elem: any) => elem.id === +key);
            }
          },
        );
        setContractAssociation(objToContractAssociation);
        break;
    }
  };

  return {
    handleAssociation,
    setOpenAssociation,
    handleDelete,
    getValues,
    resetContractAssociations,
    setSupplierAssociation,
    setContractAssociation,
    contractAssociation,
    supplierAssociation,
    openAssociations,
  };
};
